// Lightweight Privacy-First Analytics Helper
export const initAnalytics = () => {
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    const consent = localStorage.getItem('cookie_consent');

    if (gaId && consent === 'accepted' && typeof window !== 'undefined') {
        if (!document.getElementById('ga-script')) {
            const script = document.createElement('script');
            script.id = 'ga-script';
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            document.head.appendChild(script);

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag('js', new Date());
            gtag('config', gaId, {
                anonymize_ip: true,
                cookie_flags: 'SameSite=None;Secure'
            });
        }
    }
};
